// Google Analytics utility functions
declare global {
  interface Window {
    gtag: (...args: any[]) => void;
    dataLayer: any[];
  }
}

// Google Analytics Measurement ID for dineai.ai
export const GA_MEASUREMENT_ID = 'G-2SNP3BKGRY';

// Initialize Google Analytics
export const initGA = () => {
  // Only initialize if consent was given
  const consent = localStorage.getItem('cookieConsent');
  if (!consent) return;
  
  const cookiePrefs = JSON.parse(consent);
  if (!cookiePrefs.analytics) return;

  // Add the Google Analytics script
  const script1 = document.createElement('script');
  script1.async = true;
  script1.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(script1);

  // Initialize gtag
  window.dataLayer = window.dataLayer || [];
  window.gtag = function() {
    window.dataLayer.push(arguments);
  };
  window.gtag('js', new Date());
  window.gtag('config', GA_MEASUREMENT_ID, {
    page_path: window.location.pathname,
  });
};

// Track page views
export const pageview = (url: string) => {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('config', GA_MEASUREMENT_ID, {
      page_path: url,
    });
  }
};

// Track events
export const event = ({ action, category, label, value }: {
  action: string;
  category: string;
  label?: string;
  value?: number;
}) => {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('event', action, {
      event_category: category,
      event_label: label,
      value: value,
    });
  }
};

// Track user signups
export const trackSignup = (method: string) => {
  event({
    action: 'sign_up',
    category: 'engagement',
    label: method,
  });
};

// Track plan selection
export const trackPlanSelection = (plan: string, billing: string) => {
  event({
    action: 'select_plan',
    category: 'conversion',
    label: `${plan}_${billing}`,
  });
};

// Track menu uploads
export const trackMenuUpload = (itemCount: number) => {
  event({
    action: 'menu_upload',
    category: 'engagement',
    value: itemCount,
  });
};

// Track AI image generation
export const trackAIImageGeneration = (count: number) => {
  event({
    action: 'ai_image_generation',
    category: 'feature_usage',
    value: count,
  });
};